import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SheetFormComponent } from '../components/sheet-form/sheet-form.component';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule
    ],
    declarations: [
        SheetFormComponent
    ],
    exports: [
        SheetFormComponent
    ]
})

export class SharedModule { }
